'use client';

import { Film } from '@/app/[locale]/(rest)/films/[slug]/page';
import { useDialogContext } from '@/contexts/DialogContext';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';
import CartDialog from '../blocks/CartDialog';
import { FilmListItem } from '../blocks/FilmCard';
import Image from '../Image';
import Button from './Button';

export type AddToCartFilm = Film | FilmListItem;

interface AddToCartButtonProps {
    film: AddToCartFilm;
}

const AddToCartButton = (props: AddToCartButtonProps) => {
    const { film } = props;
    const t = useTranslations();
    const { enqueueDialog } = useDialogContext();
    const openCartDialog = () => enqueueDialog(<CartDialog film={film} />);
    const isScreeningsExists = film.screenings ? film.screenings.length > 0 : false;

    const isPartOfShortProgramme =
        film.short_programme &&
        film.short_programme.screenings &&
        film.short_programme.screenings.length > 0;
    // TODO: FIX
    // const isAddToCartDisabled = !isScreeningsExists && !isPartOfShortProgramme;
    const isAddToCartDisabled = true;

    return (
        <Button
            id="add-to-basket-trigger"
            className={cn(
                'flex items-center max-sm:w-full border-primary border border-solid py-2 px-5 md:px-20 h-fit',
                isAddToCartDisabled ? 'bg-disabled border-disabled' : '',
            )}
            onClick={openCartDialog}
            variant="secondary"
            title={!isAddToCartDisabled ? t('Cart.addToBasket') : t('Cart.notAvailable')}
            textClasses="font-trade-gothic text-2xl leading-none"
            disabled={isAddToCartDisabled}
        >
            {!isAddToCartDisabled ? (
                <Image
                    className="ml-4"
                    src="/img/icons/basket-black.svg"
                    alt="Basket Icon"
                    width={36}
                    height={36}
                />
            ) : (
                <></>
            )}
        </Button>
    );
};

export default AddToCartButton;
